import { render, staticRenderFns } from "./YearEndLeaveBalances.vue?vue&type=template&id=0bfde318"
import script from "./YearEndLeaveBalances.vue?vue&type=script&lang=js"
export * from "./YearEndLeaveBalances.vue?vue&type=script&lang=js"
import style0 from "./YearEndLeaveBalances.vue?vue&type=style&index=0&id=0bfde318&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports